import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";

import FormControlLabel from "@mui/material/FormControlLabel";

const EditHeader = (props: { headerList: any; setHeaderList: any }) => {
  type IconProps = {
    color: string;
    size?: string;
  };

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const optionStyles = styled(Typography)`
    margin-top: 0;
  `;

  function DragIcon({ color = "black", size = "16" }) {
    return (
      <svg
        version="1.1"
        viewBox="0 0 36 36"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
        role="img"
        fill={color}
        width={size}
        height={size}
      >
        <circle
          cx="15"
          cy="12"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-1"
        ></circle>
        <circle
          cx="15"
          cy="24"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-2"
        ></circle>
        <circle
          cx="21"
          cy="12"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-3"
        ></circle>
        <circle
          cx="21"
          cy="24"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-4"
        ></circle>
        <circle
          cx="21"
          cy="18"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-5"
        ></circle>
        <circle
          cx="15"
          cy="18"
          r="1.5"
          className="clr-i-outline clr-i-outline-path-6"
        ></circle>
      </svg>
    );
  }
  function HeaderAdjustIcon({ color, size = "16px" }: IconProps) {
    return (
      <svg
        version="1.1"
        viewBox="0 0 36 36"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        focusable="false"
        role="img"
        height={size}
        width={size}
      >
        <path
          className="clr-i-outline clr-i-outline-path-1"
          d="M31,5H5A2,2,0,0,0,3,7V29a2,2,0,0,0,2,2H31a2,2,0,0,0,2-2V7A2,2,0,0,0,31,5ZM13,29H5V7h8Zm10,0H15V7h8Z"
          fill={color}
        ></path>
      </svg>
    );
  }

  const dragStart = (e, index) => {
    const target = e.target;

    e.dataTransfer.setData("header_index", index);

    setTimeout(() => {
      target.style.display = "none";
    }, 0);
  };

  const dragOver = (e) => {
    e.stopPropagation();
  };

  const onDrop = (e, index) => {
    const draggedFromIndex = e.dataTransfer.getData("header_index");
    // moveHeader(draggedFromIndex, index);
    console.log("draggedFromIndex", draggedFromIndex, "index", index);
  };

  function moveHeader(draggedFromIndex, droppedAtIndex) {
    // Convert the headerList object to an array
    const headerArray = Object.entries(props.headerList);

    // Perform the reordering
    const draggedItem = headerArray[draggedFromIndex];
    headerArray.splice(draggedFromIndex, 1);
    headerArray.splice(droppedAtIndex, 0, draggedItem);

    // Convert the array back to an object
    const newHeaderList = Object.fromEntries(headerArray);

    // Update the state
    props.setHeaderList(newHeaderList);
  }

  return (
    <div>
      <button
        onClick={handleClick}
        className="button-small"
        style={{
          width: 32,
          height: 22,
          padding: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <HeaderAdjustIcon color="black" />
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div style={{ margin: "5px 0px 5px 2px" }}>
          {Object.entries(props.headerList).map((item, index) => {
            const key = item[0];
            const header = item[1] as any;
            return (
              <div
                // draggable
                onDragStart={(e) => {
                  dragStart(e, index);
                }}
                onDragOver={dragOver}
                onDrop={(e) => {
                  onDrop(e, index);
                }}
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  margin: "0px 16px 0px 16px",
                }}
              >
                <div
                  onMouseEnter={(e) => (e.currentTarget.style.cursor = "grab")}
                >
                  <DragIcon color="black" />
                </div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={header.show}
                      onChange={(e) => {
                        const newHeaderList = { ...props.headerList };
                        newHeaderList[key].show = e.target.checked;
                        props.setHeaderList(newHeaderList);
                      }}
                      sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                    />
                  }
                  label={
                    <Typography
                      variant="h6"
                      sx={{ m: 0 }}
                      style={{ margin: 0 }}
                    >
                      {header.label}
                    </Typography>
                  }
                />
              </div>
            );
          })}
        </div>
      </Popover>
    </div>
  );
};

export default EditHeader;
